import { provideDataItem } from 'scrivito'

import { getInstanceIdFromUrl } from '@/utils/getInstanceIdFromUrl'
import { PISA_BASE_URL } from '@/utils/getPisaBaseUrl'

const restApiURL = () => {
  return `${PISA_BASE_URL}/${getInstanceIdFromUrl()}`
}

export const InstanceInfo = provideDataItem('InstanceInfo', {
  title: 'Instance Info',
  restApi: { url: restApiURL(), authViaInstance: getInstanceIdFromUrl() },
  attributes: {},
})
